import {
  authInitializedState,
  currentUserAuthTypeState,
  currentUserIDState,
} from '@atom/setting/user';
import { ACCESS_TYPE, ACCESS_TYPE_VALUE } from '@typings/common/accessType';
import { AUTH_TYPE } from '@typings/common/authorizationType';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useCollection } from '@nandorojo/swr-firestore';
import {
  IMemberRole,
  MEMBER_ROLE_COLLECTION,
} from '@typings/setting/memberRole.interface';

type Props = {
  accessType: ACCESS_TYPE_VALUE;
  children: any;
};
function ProtectedRoute({ accessType, children }: Props) {
  const currentUserType = useRecoilValue(currentUserAuthTypeState);
  const currentUserId = useRecoilValue(currentUserIDState);
  const authInitialized = useRecoilValue(authInitializedState);

  // 멤버 역할 정보 가져오기
  const { data: roleList } = useCollection<IMemberRole>(
    MEMBER_ROLE_COLLECTION,
    { listen: true },
  );

  // 현재 사용자의 역할 찾기
  const userRole = roleList?.find((role) =>
    role.userIds?.includes(currentUserId || ''),
  );

  // 멤버이면서 역할이 있는 경우
  const isMemberWithRole = currentUserType === AUTH_TYPE.MEMBER && !!userRole;

  // Firebase Auth 초기화가 완료되지 않은 경우, 접근 제어를 보류 (race condition 방지)
  if (!authInitialized) {
    return null;
  }

  // master는 모두 접근 가능
  if (currentUserType === AUTH_TYPE.MASTER) {
    return children;
  }

  // 게시판의 접근 권한과 유저의 권한 비교
  switch (accessType) {
    case ACCESS_TYPE.PUBLIC:
      return children;
    case ACCESS_TYPE.MEMBER:
      // 멤버 또는 게스트 모두 접근 가능 (로그인 멤버만 허용하려면 GUEST 제외)
      if (
        currentUserType === AUTH_TYPE.MEMBER ||
        currentUserType === AUTH_TYPE.GUEST
      ) {
        return children;
      } else {
        return <Navigate to="/" replace />;
      }
    case ACCESS_TYPE.SECRET:
      // 관리자 또는 역할이 있는 멤버만 접근 허용
      if (currentUserType === AUTH_TYPE.MASTER || isMemberWithRole) {
        return children;
      } else {
        return <Navigate to="/" replace />;
      }
    default:
      return <Navigate to="/" replace />;
  }
}

export default ProtectedRoute;
